import { CategorySuggestion, ProductSuggestion } from "@hermes/api-model-shell";
import {
    FlatDiscoveryCategories,
    getGridDiscoveryPath,
} from "@hermes/states/menu";

import { Suggestion } from "../model/suggestions";

export const LIMIT_SUGGESTION_CATEGORIES = 3;
export const LIMIT_TOTAL_SUGGESTION = 5;

/**
 * Format CategorySuggestions into Suggestion and filter on categories with visible products
 *
 * @param categorySuggestions CategorySuggestions to format and filter
 * @param categories Category list
 */
export const formatAndFilterCategorySuggestionsDiscovery = (
    categorySuggestions: CategorySuggestion[],
    categories: FlatDiscoveryCategories,
): Suggestion[] => {
    const suggestions: Suggestion[] = [];

    for (const suggestion of categorySuggestions) {
        if (
            suggestions.length < LIMIT_SUGGESTION_CATEGORIES &&
            categories[suggestion.pimCode.toUpperCase()]
        ) {
            suggestions.push({
                label: suggestion.label,
                quantity: suggestion.results,
                url: getGridDiscoveryPath(
                    categories[suggestion.pimCode.toUpperCase()],
                ),
            });
        }
    }

    return suggestions;
};

export const formatProductSuggestionsDiscovery = (
    urlPrefix: string,
    suggestions: ProductSuggestion[],
    nbSuggestCategories: number,
): Suggestion[] => {
    const suggestedProducts: Suggestion[] = [];
    for (const [index, product] of suggestions.entries()) {
        if (index >= LIMIT_TOTAL_SUGGESTION - nbSuggestCategories) {
            return suggestedProducts;
        }
        if (
            !suggestedProducts.some(
                (suggestProduct) =>
                    suggestProduct.label === product.label &&
                    suggestProduct.sku?.includes(product?.sku.slice(0, 9), 0),
            )
        ) {
            suggestedProducts.push({
                label: product.label,
                url: `${urlPrefix}${product.url}`,
                sku: product.sku,
            });
        }
    }
    return suggestedProducts;
};
